import { LogoType } from '@Components/Base';
import {
  MaterialRequisitionDocumentResponse,
  MaterialRequisitionItemFormResponse,
} from '@Types/api/form';
import { getFileTypeExt } from '@Features/utils/document';
import { TypeDict } from '@Types/index';
import { ColumnDocumentDataType, ColumnMaterialDataType } from './type';
import { ResponseListType } from '../types';

export const prepareCodeName = (code1: string, code2: string): string => {
  if (code1 && code2) {
    return `${code1} / ${code2}`;
  }

  if (code1 && !code2) {
    return code1;
  }

  if (!code1 && code2) {
    return code2;
  }

  return '';
};

export const dataSourceMap = (
  data: ResponseListType,
  documentTypes: TypeDict[]
): ColumnMaterialDataType[] | ColumnDocumentDataType[] => {
  const dataMaterial = data as MaterialRequisitionItemFormResponse[];

  const dataDocument = data as MaterialRequisitionDocumentResponse[];

  if (dataMaterial && dataMaterial[0]?.reqItemId) {
    const mappedMaterials = dataMaterial?.map((requestItem) => {
      const activityResCodeValue = prepareCodeName(
        requestItem.actCode,
        requestItem.resCode
      );
      const plantLedgerCodeValue = prepareCodeName(
        requestItem.plantCode,
        requestItem.ledgerCode
      );

      const activityResName = prepareCodeName(
        requestItem.actName || '',
        requestItem.resDesc || ''
      );

      const plantLedgerName = prepareCodeName(
        requestItem.plantName || '',
        requestItem.ledgerName || ''
      );

      return {
        key: requestItem.reqItemId,
        no: requestItem.reqItemId,
        activityResCode: activityResCodeValue,
        activityResName,
        activityId: requestItem.actId,
        activityName: requestItem.actName,
        plantId: requestItem.plantId,
        plantName: requestItem.plantName,
        plantLedgerCode: plantLedgerCodeValue,
        plantLedgerName,
        ledgerId: requestItem.ledgerId,
        ledgerName: requestItem.ledgerName,
        materialCode: requestItem.matCode,
        materialId: requestItem.matId,
        materialDesc: requestItem.matDesc,
        unit: requestItem.unitName,
        requiredQuantity: requestItem.reqQty,
        remarks: requestItem.transferRemarks,
        action: '',
      };
    });

    return mappedMaterials as ColumnMaterialDataType[];
  }

  if (dataDocument && dataDocument[0]?.docName) {
    return dataDocument.map((documentItem) => ({
      key: documentItem.filePath,
      no: documentItem.filePath,
      document: documentItem,
      docName: documentItem.docName,
      docType:
        documentTypes.find(
          (documentType) => documentType.codeNum === documentItem.procDocTypeId
        )?.codeDesc || 'N/A',
      docStatus: !documentItem.deleteFlag ? 'Active' : 'Inactive',
      docFormat: <LogoType fileExt={getFileTypeExt(documentItem.filePath)} />,
      description: documentItem.docDesc,
      action: '',
    })) as ColumnDocumentDataType[];
  }

  return [];
};
